import * as types from './mutations-types'

export default {
  [types.SET_STORIES](state, stories) {
    state.stories = stories
  },
  [types.SET_STORIES_LIST](state, storiesList) {
    state.storiesList = storiesList
  },
  // eslint-disable-next-line
  [types.SET_SHOW_STORIES](state, show) {
    state.showStories = false
  },
  [types.SHOW_PROACTIVE_MSG](state, value) {
    state.showProactiveMsg = value
  },
  [types.SET_SELECTED_STORIES](state, storie) {
    state.selectedStorie = storie
  },
  [types.ENABLE_VUEPER_STORIES](state) {
    state.vueperStoriesDisabled = false
  },
  [types.DISABLE_VUEPER_STORIES](state) {
    state.vueperStoriesDisabled = true
  },
  [types.MANUAL_CLOSE_PROACTIVE_MESSAGE](state) {
    state.manualCloseProactiveMessage = true
  }
}
